import ApiProcessor from '@lib/processors/api-processor'
import ClaimStatusComponent from '../../components/claim-status'

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date',
    format: 'dateTime',
    icon: 'el-icon-document',
  },
  {
    name: 'createdBy.firstName',
    label: 'User',
    format: (_, row) => {
      const { createdBy } = row
      return `${createdBy.firstName} ${createdBy.lastName}`
    },
    icon: 'el-icon-document',
  },
  {
    name: 'newStatus',
    label: 'Status',
    icon: 'el-icon-document',
    component: (_, __, { row }) => ({
      is: ClaimStatusComponent,
      props: { value: row.newStatus },
    }),
  },
]

export default component => {
  return {
    processor: new ApiProcessor({
      component,
      path: `claim-status-history?claim=/claims/${component.id}`,
    }),
    columns: TABLE_COLUMNS,
    tableName: 'claim-statuses',
  }
}
